import React from "react";
import "./VirasatDefaultHomePage.scss"
import logo from "../../assets/logo.png"
import { useHistory } from "react-router";
import { sortByOrderAscending } from "../../helper/helper";
const VirasatDefaultHeroPage = ({ components, heroBackground }) => {

    const history = useHistory()
    const getComponents = (component) => {
        switch (component.ID) {
            case "VirasatDefaultHeroPage-subheadertop":
                return <div className="VirasatDefaultHeroPage-happyhr">{component?.Props?.text}</div>
            case "VirasatDefaultHeroPage-header":
                return <div className="VirasatDefaultHeroPage-hero-header-cont">
                    <div className="VirasatDefaultHeroPage-hero-header">{component?.Props?.header}</div>
                    <div className="VirasatDefaultHeroPage-hero-subheader">{component?.Props?.subheader}</div>
                </div>
            case "VirasatDefaultHeroPage-subheaderlink":
                return <div className="VirasatDefaultHeroPage-contct"

                    onClick={() => {
                        history.push(component?.Props?.href)
                    }}>{component?.Props?.text}</div>
            default:
                return <div />
        }

    }
    return (
        <div className="VirasatDefaultHeroPage" style={{
            backgroundImage: `linear-gradient(0deg, rgba(22, 65, 106, 0.4), rgba(22, 65, 106, 0.4)),
linear-gradient(0deg, rgba(22, 65, 106, 0.2), rgba(22, 65, 106, 0.2)),
linear-gradient(0deg, rgba(22, 65, 106, 0.2), rgba(22, 65, 106, 0.2)), url(${heroBackground})`
        }}>
            <div className="VirasatDefaultHeroPage-container">
                <div className="VirasatDefaultHeroPage-container-wrapper">
                    <div className="VirasatDefaultHeroPage-logo">
                        <img alt="" className="VirasatDefaultHeroPage-logo-img" src={logo} />
                    </div>
                    {sortByOrderAscending(components).map((component, key) => {
                        return (<div key={key}>
                            {getComponents(component)}
                        </div>)
                    })}
                </div>

            </div>
        </div>
    )
}
export default VirasatDefaultHeroPage